import { gql } from '@apollo/client';

export const GET_BATCH_TESTS_FOR_FR2052A = gql`
query getBatchTestsForFR2052A($input: GetBatchTestsForFR2052AInput ) {
  getBatchTestsForFR2052A(input: $input){
    batchId
    batchRunStatus
    ruleId
    period
    fieldName
    flowType
    productId
    editTest
    isActive
    updatedAt
    totalRecords
    testPass
    testFail
    testError
    testRunStatus
    totalBatchTestRecords
    totalTestCases
    totalTestCompleted
    totalTestInError
    totalTestFailed
    fileName
    totalTestExecuted
    product
    batchStartTime
    isRuleApplicable
  }
}`;

export const GET_FAILED_TEST_RESULTS_FOR_FR2052A = gql`
query getFailedTestResultsForFR2052A($input: GetFailedTestResultsForFR2052AInput ) {
  getFailedTestResultsForFR2052A(input: $input){
    criteria{
      batchId
      ruleId
      fieldName
      flowType
      productId
      product
      editTest
      effectiveEndDate
      isActive
    }
    testResults{
      rowId
      testDate
      errorColumns
      errorData
      errorDescription
      errorMessage
      testPass
      testFail
      testError
      testRunStatus
    }
    pagination{
      totalCount
    }
  }
}`;

export const GET_AUDIT_LOGS_FOR_FR2052A = gql`
query getAuditLogsForFR2052A($input: GetAuditLogsForFR2052AInput ) {
  getAuditLogsForFR2052A(input: $input){
    eventId
    auditLogId
    commentId
    commentText
    user{
      firstName
      lastName
      initials
    }
    event{
      eventName
    }
    comment{
      commentText
    }
    createdAt
  }
}`;

export const GET_USER_COMMENTS_FOR_FR2052A = gql`
query getUserCommentsForFR2052A($input: GetUserCommentForFR2052AInput ) {
  getUserCommentsForFR2052A(input: $input){
    commentText
    commentId
    userId
    createdAt
    batchId
    ruleId
    user {
      firstName
      lastName
      initials
    }
    FR2052AAuditLog {
      eventId
      commentId
      auditLogId
      createdAt
    }
  }
}`;

export const GET_FR2052A_DOWNLOADED_RESULT = gql`
query getFR2052ASummaryDetailsForDownload($input: TenantIdInput) {
  getFR2052ASummaryDetailsForDownload(input: $input) {
    batchId
    batchRunStatus
    ruleId
    period
    flowType
    fieldName
    productId
    product
    editTest
    effectiveEndDate
    isActive
    testPass
    testFail
    testError
    testRunStatus
    totalTestCases
    totalTestCompleted
    totalTestInError
    totalTestFailed
    fileName
    totalTestExecuted
    batchStartTime
  }
}`;

export const GET_LATEST_BATCH_FOR_FR2052A = gql`
query getCurrentStatusOfLatestBatchForFR2052A($input: TenantIdInput) {
  getCurrentStatusOfLatestBatchForFR2052A(input: $input) {
    batchRunStatus
    batchId
    batchEndTime
    totalRecords
    fileName
    totalTestCases
  }
}`;

export const GET_SUMMARY_QUARTER_FOR_FR2052A = gql`
query getSummaryQuartersForFR2052A($input: TenantIdInput) {
  getSummaryQuartersForFR2052A(input: $input)
}`;

export const GET_QUARTER_FILTERED_BATCH_TEST_FOR_FR2052A = gql`
query getFR2052ABatchTestsByQuarter($input: GetBatchTestsByQuarterInput) {
  getFR2052ABatchTestsByQuarter(input: $input){
    batchId
    batchRunStatus
    ruleId
    period
    flowType
    fieldName
    productId
    product
    editTest
    isActive
    isRuleApplicable
    updatedAt
    totalRecords
    testPass
    testFail
    testError
    testRunStatus
    totalBatchTestRecords
    totalTestCases
    totalTestCompleted
    totalTestInError
    totalTestFailed
    fileName
    totalTestExecuted
    batchStartTime
  }
}`;
